import React, { useState } from "react";
import { Box, LinearProgress, TextField } from '@mui/material';
import { CreateOutlined, AddPhotoAlternateOutlined, CancelOutlined, CheckOutlined } from '@mui/icons-material';
import { Footer } from '../../components';
import FormArticulo from "./FormArticulo";
import UploadImage from "../UploadImage";
import ImagenesAIService from '../../services/imagenesAI';
import ImagenesService from '../../services/imagenes';


const FormTabsArticulo = ({ investmentAmount = 0, onCancel, onSubmit, saving, articleData = {}, createArticle = false, articles = [], storeId, uploadImage = true }) => {
  const [optionFooter, setOptionFooter] = useState(1);
  const [isValid, setIsValid] = useState(true);
  const [article, setArticle] = useState(articleData);
  const [images, setImages] = useState(articleData ? articleData.article?.images : []);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [imagePrompt, setImagePrompt] = useState('');

  const handleOptionFooter = (value) => {
    console.log(value)
    setOptionFooter(value)
    if (value === 0) onCancel && onCancel()
    if (value === 3) {
      if (uploadImage) {
        handleSubmitForm(article)
      } else {
        article.images = images
        if (onSubmit) {
          onSubmit(article)
        }
      }
    }
  }

  const onImageSelected = (images) => {
    console.log(images)
    setImages(images)
  }

  const handleSubmitForm = async (data) => {
    console.log(data)
    console.log("Submit")
    setUploadingImages(true)
    const formData = new FormData();
    // Agrega cada imagen seleccionada al formulario de datos
    images.forEach((image, index) => {
      formData.append(`image`, image);
    });
    let res;
    if (imagePrompt.trim()) {
      formData.append('prompt', imagePrompt.trim());
      res = await ImagenesAIService.generate(formData);
    } else {
      res = await ImagenesService.upload(formData);
    }
    console.log(res)
    data.images = res
    setUploadingImages(false)
    if (onSubmit) {
      onSubmit(data)
    }
    // const contenido = refAImprimir.current.innerHTML;
    // PrintService.print(contenido)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', position: 'relative', width: '100vw' }}>
      {/* <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative' }}> */}
      <Box display='flex' flexDirection='column' flex='1' sx={{ position: 'relative', width: '100%', background: 'background.default' }}>
        {/* <Box> */}
        {/* <ImprimirEtiquetas 
          refAImprimir={refAImprimir}
          quantity={article?.quantity}
          title={article?.name}
          price={article?.prices?.sale_price}
        /> */}
        {uploadingImages && <LinearProgress color='secondary' />}
        {optionFooter === 1 &&
          <FormArticulo
            sx={{ width: '100%', padding: 3 }}
            articleData={{ ...article, investment: investmentAmount, asChilds: createArticle }}
            withImages={false}
            pricesInModal={false}
            onChangeData={(value, valid) => {
              setArticle(value);
              setIsValid(valid)
            }}
            saving={saving}
            createArticle={createArticle}
            articles={articles}
          />}
        {optionFooter === 2 &&
          images && <UploadImage sx={{ background: 'background.default', width: '100%', padding: 3 }} imagesData={images} onImagesSelected={onImageSelected} uploadImage />
        }
        {optionFooter === 2 && <TextField
          size='small'
          fullWidth
          placeholder='Prompt IA para imágenes (opcional)'
          value={imagePrompt}
          onChange={(e) => setImagePrompt(e.target.value)}
          sx={{ px: 3, mt: 1 }}
        />}
      </Box>
      <Footer defaultOption={optionFooter} options={[
        { tittle: 'Cancel', icon: <CancelOutlined />, disabled: false, backgroundColor: 'error.light', colorFont: 'error.dark' },
        { tittle: 'Datos', icon: <CreateOutlined />, disabled: false },
        { tittle: 'Imagenes', icon: <AddPhotoAlternateOutlined />, disabled: false },
        { tittle: 'Guardar', icon: <CheckOutlined />, disabled: !isValid, backgroundColor: 'success.light', colorFont: 'success.dark' },
      ]} onOptionSelected={handleOptionFooter} />
      {/* </div> */}
    </Box>
  )
}

export default FormTabsArticulo;